import { type ChainFullId, ChainNamespaces } from "@umami/chains";
import { useAppSelector, useContactsForSelectedNetwork, useImplicitAccounts } from "@umami/state";
import { type FieldValues, type Path } from "react-hook-form";

import { AddressAutocomplete } from "./AddressAutocomplete";
import { type BaseProps } from "./BaseProps";
import { getFlattenedAccountsByChains } from "./utilts";

export const KnownAccountsAutocomplete = <T extends FieldValues, U extends Path<T>>(
  props: BaseProps<T, U> & { chainId?: ChainFullId }
) => {
  const contacts = useContactsForSelectedNetwork();
  const implicitAccounts = useImplicitAccounts();
  const saplingState = useAppSelector(s => s.sapling);

  const accounts = getFlattenedAccountsByChains(implicitAccounts);

  const saplingAccounts = implicitAccounts.flatMap(account => {
    const saplingData = saplingState[account.address.pkh];

    if (!saplingData) {
      return [];
    }

    return [
      {
        name: account.label,
        pkh: saplingData.viewingKeyAddress,
        chainNamespace: ChainNamespaces.TEZOS,
      },
    ];
  });

  const allAccounts = [...contacts, ...accounts, ...saplingAccounts];

  return <AddressAutocomplete {...props} contacts={allAccounts} />;
};
